import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { ExpandedTable } from "@ryde/controls";

import { GenericUploadColumnConflictsContext } from "../../contexts";
import { ColumnConflictsExpanded } from "./column-conflicts-expanded";

export const ColumnConflictsTable: FC = () => {
  const { conflicts } = useContext(GenericUploadColumnConflictsContext);
  const { t } = useTranslation();

  return (
    <ColumnConflictsExpanded>
      <ExpandedTable dataE2E="column-conflicts-table">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t("general.column")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {conflicts?.map((conflict, index) => (
              <TableRow key={`${conflict.column}_${index}`}>
                <TableCell>{conflict.column}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ExpandedTable>
    </ColumnConflictsExpanded>
  );
};
